import { createFilterGroup, createFilterLine, type FilterGroupItem } from '@civilgrid/ui/utils';
import { RequestStatus } from '~/common/types';

const notInternalOrg = () => createFilterLine('organization.isInternal', 'eq', 'false');
const notComplete = () => createFilterLine('requestStatus', 'neq', RequestStatus.Complete);
const notCancelled = () => createFilterLine('requestStatus', 'neq', RequestStatus.Cancelled);
const notDismissed = () => createFilterLine('requestStatus', 'neq', RequestStatus.Dismissed);
const isPending = () => createFilterLine('requestStatus', 'eq', RequestStatus.Pending);
const isFlagged = () => createFilterLine('isFlagged', 'eq', 'true');

export function getAllOpenRequests(): FilterGroupItem {
  return createFilterGroup([notInternalOrg(), notComplete(), notCancelled(), notDismissed()]);
}

export function getPendingRequests(): FilterGroupItem {
  return createFilterGroup([notInternalOrg(), isPending()]);
}

export function getAssignedToMe(id?: string): FilterGroupItem {
  return createFilterGroup([
    createFilterLine('assignedTo.id', 'eq', id ?? ''),
    notInternalOrg(),
    notComplete(),
    notCancelled(),
    notDismissed(),
  ]);
}

export function getFlaggedRequests(): FilterGroupItem {
  return createFilterGroup([notInternalOrg(), isFlagged()]);
}

export function getNeedsFollowUp(id?: string): FilterGroupItem {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  return createFilterGroup([
    createFilterLine('assignedTo.id', 'eq', id ?? ''),
    notInternalOrg(),
    notComplete(),
    notCancelled(),
    notDismissed(),
    createFilterLine('nextFollowUpAt', 'lt', today.toISOString()),
  ]);
}

export function getOpenRequestsNeedingFollowup(id?: string): FilterGroupItem {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  return createFilterGroup([
    notInternalOrg(),
    notComplete(),
    notCancelled(),
    notDismissed(),
    createFilterLine('nextFollowUpAt', 'lt', today.toISOString()),
    createFilterLine('assignedTo.id', 'eq', id ?? ''),
  ]);
}
